module.exports = __webpack_public_path__ + "img/CodiTiers.6bef7f6c.png";